export default __webpack_public_path__ + "static/media/review.551097d8.jpg";